import { Box } from "@mui/material";
import React, { useState, useEffect, useCallback } from "react";
import styles from "./addVehilceForm.module.scss";
import MultistepForm, {
  FormStep,
} from "../../../../components/mutiStepForm/MultistepForm";
import * as Yup from "yup";
import moment from "moment";
import {
  dropdownValueYesNoNeumeric,
  generalValidationMessage,
  getDropDownValue,
} from "../../../../config/appConfig";
import i18next from "i18next";
import VehicleFormSection from "./VehicleFormSection";
import {
  licencePlateRegx,
  licencePlateReg,
} from "../../../../utils/validation";
import {
  getVehicleDetails,
  postVehicleDetails,
  getCertificatesList,
} from "../../../../services/APIService";
import _ from "lodash";
import { useApiErrorModalContext } from "../../../../errorHandling/ApiErrorModalContext";
import PropTypes from "prop-types";

const AddVehilceForm = (props) => {
  const {
    setShowMessage,
    setSnackBarEditMessage,
    onCancel,
    dealerNo = 0,
    vehicleId = 0,
    refreshTable,
  } = props;
  const translatedGeneralValidationMessage = `${i18next.t(
    generalValidationMessage
  )}`;

  const licensePlateErrorMsg = i18next.t("Please enter valid license number");
  const VINErrorMsg = i18next.t("Please enter valid VIN");
  const defaultInitialValue = {
    vehicle_Id: vehicleId,
    dealer_Id: dealerNo,
    dealerName: null,
    license_Plate_No: "",
    vin: "",
    make: "",
    model: "",
    type: "",
    kilometer_Stand: null,
    lastPost: "",
    date_of_Admission: "",
    is_certificatesMandatory:false,
    certificates: [
      {
        certificate_Name: null,
        certificate_Status: true, //need to cross check
        updatedDate: moment(new Date()).format("DD-MM-YYYY"),
      },
    ],
    ad_Status: null,
    ad_Status_Date: null,
  };
  const [vehicleDetails, setVehicleDetails] = useState(defaultInitialValue);
  const [assignCertificatesOptions, setAssignCertificatesOptions] = useState(
    []
  );
  const { setApiErrorModalState } = useApiErrorModalContext();

  const getCertificateList = useCallback(() => {
    getCertificatesList({})
      .then((response) => {
        if (
          !_.isEmpty(_.get(response, "errorMessage", "")) ||
          _.get(response, "success", true) === false
        ) {
          _.set(response, "status", 200);

          setApiErrorModalState({ error: response });
        } else {
          setAssignCertificatesOptions(response);
        }
      })
      .catch((err) => {
        setApiErrorModalState({ error: err });
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    getCertificateList();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (vehicleId === 0) {
      setVehicleDetails(defaultInitialValue);
    } else if (assignCertificatesOptions.length > 0) {
      getVehicleDetails({ vehicleId: vehicleId })
        .then((response) => {
          if (!_.isEmpty(_.get(response, "errorMessage", ""))) {
            _.set(response, "status", 200);

            setApiErrorModalState({ error: response });
          } else if (_.get(response, "success", true) === false) {
            _.set(response, "status", 200);
            setApiErrorModalState({
              error: response,
            });
          } else {
            if (!_.isEmpty(_.get(response, "certificates", []))) {
              let updatedCertificateList = _.get(
                response,
                "certificates",
                []
              ).map((certificate) => {
                let keyValuePair = certificate.certificate_Name === "Combined_Certificate" ? "Combined_Certificate" : getDropDownValue(
                  _.get(certificate, "certificate_Name", ""),
                  assignCertificatesOptions
                );

                _.set(certificate, "certificate_Name", keyValuePair);
                _.set(
                  certificate,
                  "updatedDate",
                  moment(_.get(certificate, "updatedDate", null)).format(
                    "DD-MM-YYYY"
                  )
                );

                return certificate;
              });
              _.set(response, "certificates", updatedCertificateList);
            }
            _.set(
              response,
              "date_of_Admission",
              moment(_.get(response, "date_of_Admission", null)).format(
                "DD-MM-YYYY"
              )
            );

             _.set(
              response,
              "ad_Status_Date",
              moment(_.get(response, "ad_Status_Date", null)).format(
                "DD-MM-YYYY"
              )
            );
             
            _.set(
              response,
              "ad_Status",
              getDropDownValue(
                _.get(response, "ad_Status", null),
                dropdownValueYesNoNeumeric
              )
            );
            _.set(
              response,
              "dealerName",
              _.get(response, "keyValuePairDealer", null)
            );
            _.set(
              response,
              "is_certificatesMandatory",
              _.get(response, "is_certificatesMandatory", false)
            );
            
            // removing to avoid edit issue
            let keysTobeRemoved = Object.keys(response).filter((key) =>
              key.includes("status_")
            );
            keysTobeRemoved.forEach((attri) => delete response[attri]);

            setVehicleDetails(response);
          }
        })
        .catch((err) => {
          setApiErrorModalState({ error: err });
        });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [assignCertificatesOptions]);

  const onVehicleSubmit = (values) => {
    const updatedValues = {
      ...values,
      license_Plate_No: values.license_Plate_No?.toUpperCase(),
    };
    postVehicleDetails(updatedValues)
      .then((response) => {
        if (
          !_.isEmpty(_.get(response, "errorMessage", "")) ||
          _.get(response, "success", true) === false
        ) {
          _.set(response, "status", 200);

          setApiErrorModalState({ error: response });
        } else {
          refreshTable();
          setSnackBarEditMessage(response?.message);
          setShowMessage(true);
          onCancel();
        }
      })
      .catch((err) => {
        setApiErrorModalState({ error: err });
      });
  };

  const validation = Yup.object().shape({
    
    license_Plate_No: Yup.string(translatedGeneralValidationMessage)
      .matches(licencePlateRegx || licencePlateReg, licensePlateErrorMsg)
      .max(8, licensePlateErrorMsg)
      .min(5, licensePlateErrorMsg)
      .test(
        "oneOfRequired",
        "Kenteken of VIN is vereist",
        function (item, testContext) {
          return testContext.parent.license_Plate_No || testContext.parent.vin;
        }
      ),
    vin: Yup.string()
      .typeError(VINErrorMsg)
      .max(17, "lengte moet 17 zijn")
      .min(17, "lengte moet 17 zijn")
      .test(
        "oneOfRequired",
        "Kenteken of VIN is vereist",
        function (item, testContext) {
          return testContext.parent.license_Plate_No || testContext.parent.vin;
        }
      ),

    dealerName: Yup.object()
      .typeError(translatedGeneralValidationMessage)
      .required(translatedGeneralValidationMessage),
    make: Yup.string()
      .typeError(translatedGeneralValidationMessage)
      .required(translatedGeneralValidationMessage),
    model: Yup.string()
      .typeError(translatedGeneralValidationMessage)
      .required(translatedGeneralValidationMessage),
    kilometer_Stand: Yup.number(translatedGeneralValidationMessage)
      .typeError(translatedGeneralValidationMessage)
      .nullable(true),
    ad_Status: Yup.object()
      .typeError(translatedGeneralValidationMessage)
      .required(translatedGeneralValidationMessage),
    date_of_Admission: Yup.string()
      .typeError(translatedGeneralValidationMessage)
      .required(translatedGeneralValidationMessage),
  });

  return (
    <Box
      className={styles.addVehilceFormWrapper}
      id="addVehilceFormWrapper"
      data-testid="add-vehicle-form"
    >
      <MultistepForm
        defaultValue={vehicleDetails}
        onSubmit={(values) => {
          onVehicleSubmit(values);
        }}
        onCancel={onCancel}
        hasHeader={false}
      >
        <FormStep
          stepName=""
          onSumbit={() => console.log("Step1 submit")}
          validationSchema={validation}
        >
          <VehicleFormSection
            assignCertificatesOptions={assignCertificatesOptions}
          />
        </FormStep>
      </MultistepForm>
    </Box>
  );
};
export default AddVehilceForm;
AddVehilceForm.propTypes = {
  setShowMessage: PropTypes.any,
  onCancel: PropTypes.func,
  dealerNo: PropTypes.any,
  refreshTable: PropTypes.any,
  vehicleId: PropTypes.any,
  setSnackBarEditMessage:PropTypes.any,
};
